export default "__VITE_ASSET__B0K4cI2Y__"